import { OrganizationConfig } from 'services/organization/type';

type GetDefaultAgentNameProps = {
  organizationConfig?: OrganizationConfig | null;
  agentName: string | undefined;
  agentId: string | undefined | null;
  userName: string;
};

export const getDefaultAgentName = ({
  organizationConfig,
  agentName,
  agentId,
  userName
}: GetDefaultAgentNameProps) => {
  if (agentName) {
    return agentName;
  }

  if (organizationConfig?.agent?.name) {
    return organizationConfig.agent.name;
  }

  if (agentId) {
    return '';
  }

  return userName;
};
